import React, { FC } from 'react';
import { NavigationContentLinkTitle } from '../../Links/Links';
import { useUrlBuilder } from '../../../hooks/useUrlBuilder';
import { displayAlphabet } from '../../../helpers/alphabet';

const NavigationDesignersAlphabet: FC<{ url: string }> = ({ url }) => {
  const { localized } = useUrlBuilder();
  return (
    <>
      <NavigationContentLinkTitle color={'black'} href={localized(`${url}`)} id={`nav-title-sublink-all-designers`}>
        Designers A-Z
      </NavigationContentLinkTitle>
      <div className="alphabet-container">
        {displayAlphabet({ nav: true }).map((na, index) => (
          <div key={`letter_${na}`} className="alphabet-cell">
            <div style={{ textAlign: 'center', width: index === 0 ? '22px' : '10px' }}>
              <a className="alphabet-letter" href={localized(`${url}#${na}`)}>
                {na}
              </a>
            </div>
          </div>
        ))}
        <span style={{ flex: 1 }} />
      </div>
      <div style={{ color: 'black', margin: '10px 0 0', textDecoration: 'underline' }}>
        <a href={localized(`${url}`)} style={{ fontSize: '15px' }}>
          View all
        </a>
      </div>
      <style jsx>
        {`
          .alphabet-container {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-evenly;
            margin-top: 10px;
            width: 250px;
          }

          .alphabet-cell {
            color: black;
            padding: 5px 0;
            width: 50px;
          }

          .alphabet-letter {
            cursor: pointer;
            font-size: 15px;
          }
        `}
      </style>
    </>
  );
};

export { NavigationDesignersAlphabet };
